// extracted by mini-css-extract-plugin
export var alertIcon = "_rg-0";